module.exports = __webpack_public_path__ + "img/acc_c.e69618da.png";